import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { ElementCategory, ElementType } from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  DividerElement,
} from "@easy-email-pro-core/typings";
import { BasicBlock } from "@easy-email-pro-core/components";
import React from "react";

const defaultData: ElementDefinition<DividerElement>["defaultData"] = {
  attributes: {
    align: "center",
    "border-width": "4px",
    "border-style": "solid",
    "border-color": "#000000",
    padding: "10px 25px",
    "padding-top": "10px",
    "padding-right": "25px",
    "padding-bottom": "10px",
    "padding-left": "25px",
    width: "100%",
  },
  data: {},
};

export const Divider = createBlock<DividerElement>({
  get name() {
    return t("Divider");
  },
  defaultData,
  type: ElementType.DIVIDER,
  create: (payload) => {
    const defaultData: DividerElement = {
      type: ElementType.DIVIDER,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.DIVIDER,
  render(params) {
    return <BasicBlock params={params} tag="mj-divider" />;
  },
});
